import FormSection from './FormSection'
import { translations } from '../../data/translations'

const FilesSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.files || translations.de.files

  const handleCheckboxChange = (fieldName, value) => {
    const currentValues = formData[fieldName] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(fieldName, newValues)
  }

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      {/* 19.1 Available documents */}
      <div className="subsection">
        <h3 className="subsection-title">{t.subtitle1}</h3>
        <p className="help-text">{t.verfuegbareHelp}</p>

        <div className="form-group">
          <label className="form-group__label">{t.verfuegbareLabel}</label>
          <div className="checkbox-group checkbox-group--dense">
            {t.unterlagenOptionen.map((option) => (
              <label key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  name="unterlagen[]"
                  value={option.value}
                  checked={(formData.unterlagen || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('unterlagen', option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 19.2 Missing documents */}
      <div className="subsection">
        <h3 className="subsection-title">{t.subtitle2}</h3>

        <div className="form-group">
          <label htmlFor="fehlende_unterlagen" className="form-group__label">
            {t.fehlendeUnterlagen}
          </label>
          <textarea
            id="fehlende_unterlagen"
            name="fehlende_unterlagen"
            className="form-group__input form-group__textarea"
            rows="3"
            value={formData.fehlende_unterlagen || ''}
            onChange={(e) => updateFormData('fehlende_unterlagen', e.target.value)}
            placeholder={t.fehlendeUnterlagenPlaceholder}
          />
        </div>
      </div>

    </FormSection>
  )
}

export default FilesSection
